<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon ionic-md-information-circle_bk.png" alt="" width="27.3" height="25.2" />
      <p class="title-bk">お知らせ</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: 'notification' }">戻る</router-link>
    </div>
    <div class="container">
      <table class="table">
        <tbody>
          <tr v-if="currentNotification.importance">
            <th scoped="row" width="10%">
              <label class="lb-important">重要</label>
            </th>
            <td>
              <label class="lb-title">{{ currentNotification.title }}</label>
            </td>
          </tr>
          <tr v-else>
            <th scoped="row" width="10%" colspan="2">
              <b>{{ currentNotification.title }}</b>
            </th>
          </tr>
          <tr>
            <td colspan="2"><hr class="divide-line" /></td>
          </tr>
          <tr>
            <td colspan="2"><p v-html="currentNotification.message" /></td>
          </tr>
          <tr>
            <td colspan="2"><hr class="divide-line" /></td>
          </tr>
          <tr>
            <th class="meta-info-header" scope="row">掲載期間：</th>
            <td>{{ postPeriodDatetime(currentNotification.startDatetime, currentNotification.endDatetime) }}</td>
          </tr>
          <tr>
            <th class="meta-info-header" scope="row">カテゴリ：</th>
            <td>{{ currentNotification.category }}</td>
          </tr>
          <tr>
            <th class="meta-info-header" scope="row">表示先：</th>
            <td>{{ recipientsDisplay(currentNotification.recipientIds) }}</td>
          </tr>
        </tbody>
      </table>
      <div class="text-center">
        <button type="submit" class="btn-confirm" @click="done">戻る</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import store from '@/store/index.js';
import { basicDate, basicRecipientDisplay } from '@/presenters/fields';

export default {
  props: {
    id: {
      type: [String, Number],
      required: false,
    },
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (routeTo.params.id) {
      store.dispatch('notification/fetchNotification', routeTo.params.id).then(() => {
        next();
      });
    } else {
      next();
    }
  },
  computed: {
    currentNotification() {
      return this.notification.notification;
    },
    ...mapState(['notification']),
  },
  methods: {
    postPeriodDatetime(startDate, endDate) {
      return basicDate(startDate) + ' - ' + basicDate(endDate);
    },
    recipientsDisplay(recipientOptions) {
      return basicRecipientDisplay(recipientOptions);
    },
    done() {
      this.$router.push({ name: 'notification' });
    },
  },
};
</script>

<style scoped>
.lb-important {
  background-color: red;
  color: white;
  padding: 5px 15px 5px 15px;
}
.lb-title {
  font-weight: bold;
  padding: 5px 0px 5px 0px;
}
.btn-confirm {
  margin-left: 0px;
}
.meta-info-header {
  width: 15%;
}
</style>
